import { Textarea, AppTab } from 'ccs-ui-components';
import { useMemo, useState } from 'react';
import { Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { EventSchemaDetail } from '../../store/_api/TypeDefs';
import classes from './EventSchema.module.scss';
import AvroSchemaViewer from '../avro-schema-viewer/AvroSchemaViewer';

interface EventSchemaProps {
  eventSchema?: EventSchemaDetail;
}

const EventSchema = ({ eventSchema = undefined }: EventSchemaProps) => {
  const { t: translate } = useTranslation();
  const [activeTabKey, setActiveTabKey] = useState(1);

  const formattedJson = useMemo(() => {
    const raw = eventSchema?.schema ?? '';
    try {
      return raw ? JSON.stringify(JSON.parse(raw), null, 4) : raw;
    } catch (e) {
      return raw;
    }
  }, [eventSchema]);

  return (
    <Col data-testid="eventSchemaSideBar" className={classes.schema}>
      <AppTab
        passDefaultKey={1}
        tabKey={activeTabKey}
        passActiveKey={(key) => {
            if (key !== null) setActiveTabKey(key);
          }}
        tabs={[
            {
              tabName: String(translate('schema_details_form_components.txt_avro_schema') ?? 'Avro Schema'),
              count: 1,
              key: 1,
              tabComponent: (
                <div>
                  {eventSchema && (
                  <AvroSchemaViewer
                    eventDetails={eventSchema}
                  />
            )}
                </div>
              )
            },
            {
              tabName: String(translate('schema_details_form_components.lbl_schema_description') ?? 'Event Schema'),
              count: 1,
              key: 2,
              tabComponent: (
                <div className={classes['raw-view']}>
                  <Textarea className={classes['raw-textarea']} label="" id="event-schema-raw" name="event-schema-raw" readOnly value={formattedJson} />
                </div>
              )
            }
          ]}
      />
    </Col>
  );
};

export default EventSchema;
